type RowObj = {
	name: string;
	departamento: string;
	hotel: string;
	date: string;
	status: string;
	price: string;
	actions: string;
};

const tableDataOverview: RowObj[] = [
	{
		name: "MacBook Pro 2022 M3",
		departamento: '32,003',
		hotel: 'Casa Velas',
		date: 'Jul 20, 2022',
		status: 'APROBADO',
		price: '$2.990',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '20,741',
		hotel: 'Velas Vallarta',
		date: 'Apr 26, 2022',
		status: 'RECHAZADO',
		price: '$1.499',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '9,380',
		hotel: 'Grand Velas Riviera Maya',
		date: 'Sep 20, 2022',
		status: 'APROBADO',
		price: '$2.799',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '23,944',
		hotel: 'Grand Velas Riviera Nayarit',
		date: 'Aug 02, 2022',
		status: 'PENDIENTE',
		price: '$1.209',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '10,372',
		hotel: 'Grand Velas Riviera Nayarit',
		date: 'Jul 17, 2022',
		status: 'PENDIENTE',
		price: '$3.799',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '84,920',
		hotel: 'Casa Velas',
		date: 'Jun 08, 2022',
		status: 'APROBADO',
		price: '$2.299',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '30,724',
		hotel: 'Velas Vallarta',
		date: 'Sep 03, 2022',
		status: 'PENDIENTE',
		price: '$1.899',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '12,943',
		hotel: 'Casa Velas',
		date: 'Oct 30, 2022',
		status: 'RECHAZADO',
		price: '$2.699',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '31,842',
		hotel: 'Casa Velas',
		date: 'Aug 04, 2022',
		status: 'APROBADO',
		price: '$4.309',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '45,894',
		hotel: 'Grand Velas Los Cabos',
		date: 'Apr 21, 2022',
		status: 'APROBADO',
		price: '$3.099',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '45,894',
		hotel: 'Grand Velas Los Cabos',
		date: 'Apr 21, 2022',
		status: 'APROBADO',
		price: '$3.099',
		actions: 'Actions'
	},
	{
		name: "MacBook Pro 2022 M3",
		departamento: '45,894',
		hotel: 'Grand Velas Los Cabos',
		date: 'Apr 21, 2022',
		status: 'APROBADO',
		price: '$3.099',
		actions: 'Actions'
	}
];

export default tableDataOverview;
